export default __webpack_public_path__ + "static/media/mainpic1.9b88d6af.png";